<script setup>
import useUserService from "@/composables/useUserService";
import { ref, defineProps, defineEmits } from "vue";
import useModal from "@/composables/useModal";
import { requestExchangeOrderItem, requestReturnOrderItem } from "@/api/v4";

const props = defineProps({
  orderId: {
    type: Number,
    required: true,
  },
  orderItemId: {
    type: Number,
    required: true,
  },
  orderItemName: {
    type: String,
    required: true,
  },
});

const emits = defineEmits(["submit", "close"]);
const { alert } = useModal();

const { userId } = useUserService();

const g = ref("");
const reason = ref();

const openCancelWrite = async () => {
  if (!g.value) {
    alert("교환/반품 체크를 해주세요");
    return;
  }

  if (!reason.value) {
    alert("사유를 입력해주세요");
    return;
  }

  try {
    const payload = {
      memberId: userId.value,
      orderId: props.orderId,
      orderItemId: props.orderItemId,
      reason: reason.value,
    };

    switch (g.value) {
      case "E":
        await requestExchangeOrderItem(payload);
        break;
      case "R":
        await requestReturnOrderItem(payload);
        break;
      default:
        emits("close");
        return;
    }

    emits("submit", true);
  } catch (e) {
    const message = e.response?.data?.message;
    await alert(message || "교환/반품을 할 수 없는 상태입니다.");
    emits("close");
  }
};
</script>

<template>
  <div class="popup-bg on"></div>
  <div class="popup-cont w01 on" id="popup-change">
    <div class="popup-header">
      <h3 class="title">교환/반품 신청</h3>
      <button
        type="button"
        class="popup-close-btn popup-close"
        @click="emits('close')"
      >
        닫기
      </button>
    </div>
    <div class="popup-body">
      <p class="goods_title">
        {{ orderItemName }}
      </p>
      <div class="popup_write type-02">
        <div class="input_wrap">
          <form action="">
            <p class="input_tit">구분<strong class="required">*</strong></p>
            <div class="chk_wrap">
              <div class="chk_area radio">
                <input
                  type="radio"
                  name="causeChk"
                  id="causeChk1"
                  value="E"
                  v-model="g"
                />
                <label for="causeChk1" class="chk">
                  <i class="ico_chk"></i>
                  교환
                </label>
              </div>
              <div class="chk_area radio">
                <input
                  type="radio"
                  name="causeChk"
                  id="causeChk2"
                  value="R"
                  v-model="g"
                />
                <label for="causeChk2" class="chk">
                  <i class="ico_chk"></i>
                  반품
                </label>
              </div>
            </div>
            <p class="input_tit">
              사유 입력<strong class="required">*</strong>
            </p>
            <div class="input_area">
              <textarea
                name="changeDetail"
                id="changeDetail"
                v-model="reason"
              ></textarea>
            </div>
            <div class="btn_area">
              <button type="button" class="btn form02" @click="openCancelWrite">
                저장
              </button>
              <button
                type="button"
                class="btn popup-close"
                @click="emits('close')"
              >
                취소
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
